/**
 * Following Subject's types are relevant for Customer entity
  Person
  Foreigner
  Entrepreneur
  Business (covers Persons and Organizations)

Person, Czech citizen
  Business mandatory attributes
  lastName
  birthCode
  birthDate
  CustomerAddress

Foreigner
Business mandatory attributes
  lastName
  birthDate
  idIssueCountry
  CustomerAddress

Entrepreneur
Business mandatory attributes
  lastName (company name)
  companyRegistrationNo
  CustomerAddress

Business person or company
Business mandatory attributes
  lastName (company name)
  companyRegistrationNo or companyTaxNo or in case of "SMB" segment can be birthCode instead of companyRegistrationNo
  CustomerAddress
  subject.subjectType

 */
export type CustomerSubjectType = (typeof CustomerSubjectType)[keyof typeof CustomerSubjectType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerSubjectType = {
  Person: 'Person',
  Foreigner: 'Foreigner',
  Business: 'Business',
  Entrepreneur: 'Entrepreneur',
  UnivSubject: 'UnivSubject',
  Org: 'Org',
  Unidentified: 'Unidentified',
} as const;
